export const getDistance = (lat1: number, lng1: number, lat2: number, lng2: number): number => {
  const dx = Math.abs(lat1 - lat2);
  const dy = Math.abs(lng1 - lng2);

  return Math.sqrt(dx * dx + dy * dy);
};
